<template>
    <basic-card>
        <template slot="header">
            Operation links
        </template>
        <simple-list :columns="listColumns" object-name="operationLink">
        </simple-list>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import SimpleList from "../components/lists/SimpleList";
    import {mapGetters} from "vuex";
    export default {
        name: "OperationLinksView",
        components: {SimpleList, BasicCard},
        computed: {
             ... mapGetters({
                 "operationLinkDefinitions": "operationLinkDefinitions/operationLinkDefinitions"
             })
        },
        data() {
            return {
                listColumns: [
                    {
                        caption: "Id",
                        datum: d => d.id
                    },
                    {
                        caption: "Link name",
                        datum: d => this.operationLinkDefinitions.find(linkDef => linkDef.id == d.linkDefinition)?.name ?? "N/A"
                    },
                    {
                        caption: "Primary side",
                        datum: d => d.primarySide
                    },
                    {
                        caption: "Secondary side",
                        datum: d => d.secondarySide
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>